import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 24px;
  gap: 2px;
`;

export const Timeline = styled.div`
  display: flex;
  gap: 12px;
`;

export const TimeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: end;
  width: 96px;
  flex-shrink: 0;
  padding-bottom: 20px;
`;

export const Divisor = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

type CircleProps = {
  active: boolean;
};

export const Circle = styled.div<CircleProps>`
  width: 12px;
  height: 12px;
  border-radius: 12px;
  border: 2px solid ${({ theme }) => theme.colors.element.disabled};
  background-color: transparent;

  ${({ active, theme }) =>
    active &&
    css`
      border-color: ${theme.colors.brand.primary};
      background-color: ${theme.colors.brand.primary};
    `}
`;

type LineProps = {
  position: 'right' | 'left';
  active: boolean;
};

export const Line = styled.div<LineProps>`
  height: 100%;
  flex-grow: 1;
  -webkit-flex-grow: 1;

  ${({ position, active }) =>
    position === 'right' &&
    css`
      border-right: 1px solid ${({ theme }) => (active ? theme.colors.brand.primary : theme.colors.element.disabled)};
    `}

  ${({ position, active }) =>
    position === 'left' &&
    css`
      border-left: 1px solid ${({ theme }) => (active ? theme.colors.brand.primary : theme.colors.element.disabled)};
    `}
`;

export const LineContent = styled.div`
  display: flex;
  flex-grow: 1;
`;

type ContentProps = {
  gap: number;
  mb?: number;
};

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap}px;
  width: 100%;
  min-width: 0;

  ${({ mb }) =>
    mb &&
    css`
      padding-bottom: ${mb}px;
    `}
`;

type InfoContentProps = {
  direction?: 'row' | 'column';
};

export const InfoContent = styled.div<InfoContentProps>`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  flex-direction: ${({ direction }) => direction || 'row'};

  caption {
    color: ${({ theme }) => theme.colors.element.secondary} !important;
  }
`;

export const Action = styled.div`
  button {
    padding: 0px;
  }
`;

export const CommentsWrapper = styled.div`
  margin-top: 15px;
  max-height: calc(100vh - 95px);
  overflow: scroll;

  &::-webkit-scrollbar {
    width: 4px;
  }
`;
